export const NAME = 'contacts';

export const dialogs = {
	TOO_MANY_CONTACTS_FOR_PRINT: 'TOO_MANY_CONTACTS_FOR_PRINT',
};

export const formDataFieldsMap = {
	campaign: 'Kampaň',
	channel: 'Distribuční kanál',
	region: 'Region',
	agency: 'Oblast',
	manager: 'Manažer',
	seller: 'Obchodník',
	ppz: 'Podobchodník',
	contactState: 'Stav kontaktu',
	surname: 'Příjmení klienta',
	firstName: 'Jméno klienta',
	businessName: 'Název',
	personIn: 'Rodné číslo',
	businessIn: 'IČO',
	product: 'Produkt',
	bruttoProductionStatus: 'Produkce',
	municipality: 'Obec',
	zipCode: 'PSČ',
	policyNumber: 'Číslo PS',
};
